// extracted by mini-css-extract-plugin
export default {"button-icon":"ButtonIcon_button-icon__SVoXg","destructive":"ButtonIcon_destructive__i5Eve","light":"ButtonIcon_light__DnFFb","border":"ButtonIcon_border__ZNCdD"};